import { useCallback, useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useEventSubscription } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'

// A completion belongs to the session that started it, even after A → B → A.
export function useChatOperationScope(chatId: number | undefined, isLoggedIn: boolean, identityKey?: string) {
  const current = useRef(Symbol('chat operation scope'))
  const reset = useCallback(() => { current.current = Symbol('chat operation scope') }, [])
  useEventSubscription('reset_chat_state', reset)
  useIsomorphicLayoutEffect(() => {
    reset()
    return reset
  }, [chatId, isLoggedIn, identityKey, reset])
  return useCallback(() => {
    const owner = current.current
    return () => current.current === owner
  }, [])
}
